import { render, staticRenderFns } from "./InstallPWAMobileView.vue?vue&type=template&id=5ba45039"
import script from "./InstallPWAMobileView.vue?vue&type=script&lang=ts"
export * from "./InstallPWAMobileView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports